export default __webpack_public_path__ + "static/media/twitter.2310eb9e.svg";